<template>
    <button
        class="flex items-center justify-center w-full transition-[background]"
        :disabled="disabled"
        @click="save"
        :type="type"
        :class="{
            saving: _saving,
            completed: _completed,
        }"
    >
        <slot name="default" v-if="(!_saving && !_completed) || (_completed && !showSaved)" />

        <div v-if="_completed && showSaved" class="flex items-center -ml-4">
            <div class="border-white border-[2px] rounded-full">
                <IconTrue class="w-4.5 h-4.5 stroke-white" />
            </div>

            <p class="pl-2 text-white">Saved</p>
        </div>

        <slot name="saving" v-if="_saving">
            <div class="dot-pulse white flex shrink-0"></div>
        </slot>
    </button>
</template>

<script>
import ZapoLogoJson from '~/assets/animation-zapo-logo.json'

export default {
    props: {
        saving: Boolean,
        erorred: Boolean,
        delay: { default: 1000, type: Number },
        delayX: { default: 1000, type: Number },
        type: { default: 'submit', type: String },
        showSaved: { default: false, type: Boolean },
        disabled: { default: false, type: Boolean },
    },

    data() {
        return {
            _saving: false,
            _completed: false,
        }
    },

    methods: {
        timer() {
            setTimeout(() => {
                if (this.disabled) {
                    this.timer()
                } else {
                    this._saving = false
                }
            }, this.delay)
        },

        save() {
            this._saving = true

            this.timer()
        },
    },

    watch: {
        disabled() {
            // this._saving = !this._saving
        },
    },

    // data() {
    //     return {
    //         _saving: false,
    //         _completed: false,
    //         canComplete: false,
    //         ZapoLogoJson,
    //     }
    // },

    // methods: {
    //     save() {
    //         if (!this._saving) {
    //             this.canComplete = false
    //             this._saving = true

    //             setTimeout(() => {
    //                 // if (this.saving) {
    //                 this.canComplete = true
    //                 this.complete()
    //                 // }
    //             }, this.$help.globalSubmitDelay())
    //         }
    //     },

    //     complete() {
    //         if (this.saving || !this.canComplete) {
    //             return
    //         }

    //         this._saving = false
    //         this._completed = true

    //         setTimeout(() => {
    //             this._completed = false
    //         }, this.$help.globalSubmitDelay())
    //     },
    // },

    // watch: {
    //     saving() {
    //         if (this._saving && !this.saving) {
    //             this.complete()
    //         }
    //     },
    // },
}
</script>
